import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/crmCustomerContact/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/crmCustomerContact',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/crmCustomerContact',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/crmCustomerContact/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/crmCustomerContact',
    method: 'get',
    params: {
      id
    }
  })
}

export function listOption(params) {
  return request({
    url: '/api/crmCustomerContact/listOption',
    method: 'get',
    params
  })
}

export function list(params) {
  return request({
    url: '/api/crmCustomerContact/list',
    method: 'get',
    params
  })
}
